<div class="d-flex align-items-center justify-content-center">
  <nb-card>
    <nb-card-header class="d-flex flex-column align-items-center p-4">
      <img src="https://logos-download.com/wp-content/uploads/2016/05/IRobot_logo_green.png" height="32px" />
      <div class="mt-2" style="font-size: large">Insight Engine UI - {{ environment }}</div>
    </nb-card-header>
    <nb-card-body class="d-flex flex-column align-items-center p-4">
      <div style="font-size: x-large; font-weight: 600" i18n>You are logged out.</div>
      <div class="mt-3" i18n>You must login to use Insight Engine UI.</div>
      <button class="mt-5" nbButton status="success" (click)="login()" i18n>Login</button>
    </nb-card-body>
  </nb-card>
</div>
